import axiosClient from './axiosClient';

export const authApi = {
  login: async (email, password) => {
    const { data } = await axiosClient.post('/auth/login', { email, password });
    return data.data;
  },

  me: async () => {
    const { data } = await axiosClient.get('/auth/me');
    return data.data;
  },

  updateProfile: async (payload) => {
    const { data } = await axiosClient.put('/auth/me', payload);
    return data.data;
  },

  updatePassword: async (payload) => {
    const { data } = await axiosClient.put('/auth/password', payload);
    return data.data;
  },

  // ⚠️ NOUVEAU : mot de passe oublié
  requestPasswordReset: async (email) => {
    const { data } = await axiosClient.post('/auth/forgot-password', { email });
    return data;
  },
};